"use strict";
/**
 * a registry of unicode characters
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.nonBreakingSpace = "\u00A0";
//# sourceMappingURL=unicode.js.map